import { makeVar } from '@apollo/client'

// --- Reactive Vars ---
export const approverGroupsListVar = makeVar<any[] | undefined>(undefined)
export const selectedBackupApproverGroupsVar = makeVar<any[]>([])
export const selectForAddVar = makeVar<any[]>([])
export const selectForRemoveVar = makeVar<any[]>([])
export const hasUnsavedChangesVar = makeVar<boolean>(false)

// --- Getters ---
export const getApproverGroupsList = () => approverGroupsListVar()
export const getSelectedApproverGroups = () => selectedBackupApproverGroupsVar()
export const getSelectForAdd = () => selectForAddVar()
export const getSelectForRemove = () => selectForRemoveVar()
export const getHasUnsavedChanges = () => hasUnsavedChangesVar()

// --- Setters ---
export const setApproverGroupsList = (list: any[] | undefined) => approverGroupsListVar(list)
export const setSelectedApproverGroups = (groups: any[]) => selectedBackupApproverGroupsVar(groups)
export const setSelectForAdd = (items: any[]) => selectForAddVar(items)
export const setSelectForRemove = (items: any[]) => selectForRemoveVar(items)
export const setHasUnsavedChanges = (value: boolean) => hasUnsavedChangesVar(value)
